export default function StatCard({ label, value, icon: Icon, accent = "brand", testid, sub }) {
  const palette = {
    brand: { bg: "bg-brand-soft", text: "text-brand" },
    gold: { bg: "bg-gold-soft", text: "text-amber-600" },
    success: { bg: "bg-emerald-50", text: "text-emerald-600" },
    danger: { bg: "bg-red-50", text: "text-red-500" },
    info: { bg: "bg-sky-50", text: "text-sky-600" },
  }[accent] || { bg: "bg-brand-soft", text: "text-brand" };

  return (
    <div data-testid={testid} className="bg-white rounded-2xl p-5 border border-brand/10 shadow-sm card-hover">
      <div className="flex items-start justify-between">
        <div className={"w-11 h-11 rounded-xl flex items-center justify-center " + palette.bg + " " + palette.text}>
          {Icon ? <Icon size={20} /> : null}
        </div>
        {sub && <span className="text-[11px] uppercase tracking-widest text-brand-muted">{sub}</span>}
      </div>
      <div className="mt-5">
        <div className="font-heading font-bold text-2xl sm:text-3xl text-brand-ink leading-none">{value}</div>
        <div className="text-sm text-brand-muted mt-1.5">{label}</div>
      </div>
    </div>
  );
}
